























import { Component, Vue } from "vue-property-decorator";
import Axios from "axios";

@Component({
  components: {}
})
export default class Home extends Vue {
  data() {
    return {
      timer: null,
      timerOut: null,
      time: null,
      imgType: null,
      qrcode: {
        imgSrc: null,
        uuid: null,
        state: null
      }
    };
  }

  mounted() {
    this.getQrcode();
  }

  getQrcode() {
    Axios.post(process.env.VUE_APP_URL + "/token", {}).then(res => {
      const param = {
        option: "weixinOpen",
        obj: {
          type: "qrcode"
        }
      };
      localStorage.setItem("token", "Bearer " + res.data.token);

      Axios.defaults.headers.common["Authorization"] = localStorage.getItem(
        "token"
      );
      Axios.post(process.env.VUE_APP_URL + "/api", param).then(res => {
        res.data.imgSrc = "https://open.weixin.qq.com" + res.data.imgSrc;
        this.$data.imgType = "QRCode";
        this.$data.qrcode = res.data;
        this.$data.time = 60;
        this.$data.timerOut = setInterval(() => {
          this.$data.time--;
          if (this.$data.time == 0) {
            clearTimeout(this.$data.timer);
            clearTimeout(this.$data.timerOut);
          }
        }, 1000);
      });
      this.$data.timer = setInterval(() => {
        this.getQrconnect();
      }, 5000);
    });
  }

  getQrconnect() {
    const param = {
      option: "weixinOpen",
      obj: {
        type: "qrconnect",
        uuid: this.$data.qrcode.uuid
      }
    };
    Axios.post(process.env.VUE_APP_URL + "/api", param).then(res => {
      if (res.data.data.wx_errcode == "405") {
        this.$data.imgType = "wxQRCode";
        this.$data.qrcode.imgSrc = null;
        this.$data.time = null;
        clearTimeout(this.$data.timerOut);
        this.getWelogin(res.data.data.wx_code);
      }
    });
  }

  getWelogin(code: string) {
    const param = {
      option: "weixinOpen",
      type: "Travel",
      obj: {
        type: "welogin",
        state: this.$data.qrcode.state,
        code: code,
        wxa: {
          page: "packageCityService/pages/community/question",
          scene: code,
          width: 200,
          // eslint-disable-next-line @typescript-eslint/camelcase
          auto_color: true
        }
      }
    };
    Axios.post(process.env.VUE_APP_URL + "/api", param).then(res => {
      if (res.data.data.Key) {
        this.$data.qrcode.imgSrc = "https://img.qzwu.com/" + res.data.data.Key;
        this.$data.time = null;
        clearTimeout(this.$data.timer);
      }
    });
  }
}
